import Navbar from "./sections/navbar/Navbar";
import Header from "./sections/header/Header";
import About from "./sections/about/About";
import Services from "./sections/services/Services";
import Portfolio from "./sections/portfolio/Portfolio";
import Testimonials from "./sections/testimonials/Testimonials";
import FAQs from "./sections/faqs/FAQs";
import Contact from "./sections/contact/Contact";
import Footer from "./sections/footer/Footer";
import Modal from "./components/Model";
import FloatingNav from "./sections/floating-nav/FloatingNav";
import Theme from "./theme/Theme";
import { useThemeContext } from "./context/theme-context";
import { useRef, useState, useEffect } from "react";

const App = () => {
  const { themeState } = useThemeContext();
  const mainRef = useRef();
  const [showFloatingNav, setShowFloatingNav] = useState(true);
  const [siteYPosition, setSiteYPosition] = useState(0);

  useEffect(() => {
    // local handlers (stable within the effect)
    const showFloatingNavHandler = () => setShowFloatingNav(true);
    const hideFloatingNavHandler = () => setShowFloatingNav(false);

    const floatingNavToggleHandler = () => {
      const rectY = mainRef?.current?.getBoundingClientRect().y; // fixed typo
      if (siteYPosition < rectY - 20 || siteYPosition > rectY + 20) {
        showFloatingNavHandler();
      } else {
        hideFloatingNavHandler();
      }
      setSiteYPosition(rectY);
    };

    const checkYPosition = setInterval(floatingNavToggleHandler, 2000);
    return () => clearInterval(checkYPosition);
  }, [siteYPosition, mainRef]); // `mainRef` is stable but including it is safe

  return (
    <main
      className={`${themeState.primary} ${themeState.background}`}
      ref={mainRef}
    >
      <Navbar />
      <Header />
      <About />
      <Services />
      <Portfolio />
      <Testimonials />
      <FAQs />
      <Contact />
      <Footer />
      <Theme />
      <Modal />
      {showFloatingNav && <FloatingNav />}
    </main>
  );
};

export default App;
